import { render, staticRenderFns } from "./CouponWindow.vue?vue&type=template&id=3281dbd4"
import script from "./CouponWindow.vue?vue&type=script&lang=js"
export * from "./CouponWindow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports